import { render, staticRenderFns } from "./OrganizationImport.vue?vue&type=template&id=4543f160&scoped=true"
import script from "./OrganizationImport.vue?vue&type=script&lang=js"
export * from "./OrganizationImport.vue?vue&type=script&lang=js"
import style0 from "./OrganizationImport.vue?vue&type=style&index=0&id=4543f160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543f160",
  null
  
)

export default component.exports